
<div class="itb-rsb-feedback-panel simple-widget">
  <div class="heading widget-h widget-header">
      <itb-round-button [tooltipText]="'Apply Filters'" [className]="'light'" [iconClassName]="'tick'" (onClickHandler)="clickEvent('tick')"></itb-round-button>
      <itb-round-button [tooltipText]="'Save Filters'" [className]="'light'" [iconClassName]="'save'" (onClickHandler)="clickEvent('save')"></itb-round-button>
      <itb-round-button [tooltipText]="'Clear Filters'" [className]="'light'" [iconClassName]="'cross'" (onClickHandler)="clickEvent('cross')"></itb-round-button>
  </div>
  <div class="rsb-feedback-body">
      <div class="smily-filter">
        <a [ngClass]="ratingsObj.poorRating ? 'smiley-fil-cont active' : 'smiley-fil-cont inactive'" (click)="simileyEvent('poor')">
          <span class="smiley-img img-smiley-poor"></span>  
        </a>
        <a [ngClass]="ratingsObj.neutralRating ? 'smiley-fil-cont active' : 'smiley-fil-cont inactive'" (click)="simileyEvent('neutral')">
            <span class="smiley-img img-smiley-neutral"></span>  
        </a>
        <a [ngClass]="ratingsObj.happyRating ? 'smiley-fil-cont active' : 'smiley-fil-cont inactive'" (click)="simileyEvent('happy')">
              <span class="smiley-img img-smiley-happy"></span>  
        </a>
      </div>
      <div class="rsb-select-filter">
        <itb-select [formFieldName]="companiesField" [isDisabled]="'false'" [parentForm]="parentForm"
          [label]="'Select Companies'" [isMultiple]="true"
          [itemsStringArray]="companiesList" [isDataInStrings]="true"></itb-select>
        <itb-select [formFieldName]="resourcesField" [isDisabled]="'false'" [parentForm]="parentForm"
          [label]="'Select Resources'" [isMultiple]="true"
          [itemsStringArray]="resourcesList" [isDataInStrings]="true"></itb-select>
        <itb-select [formFieldName]="tagsField" [isDisabled]="'false'" [parentForm]="parentForm" [label]="'Select Tags'"
          [isMultiple]="true" [itemsStringArray]="tagsList"
          [isDataInStrings]="true"></itb-select>
      </div>
      <itb-date-picker [placeholder]="'Start Date'" [parentForm]="parentForm" [formFieldName]="startDateField"
        [date]="parentForm.get(startDateField).value"></itb-date-picker>

      <itb-date-picker [placeholder]="'End Date'" [parentForm]="parentForm" [formFieldName]="endDateField" 
        [date]="parentForm.get(endDateField).value"></itb-date-picker>


    <itb-select [formFieldName]="filtersField" [parentForm]="parentForm" [label]="'Select Filters'"
      [isMultiple]=false [itemsStringArray]="filtersList"
      [isDataInStrings]="true" (onChangeHandler)="filterHandler($event)">
    </itb-select>
  </div>
</div>